const authTabs = document.querySelectorAll('.authorization-tab'),
  authForms = document.querySelectorAll('.authorization-form'),
  authTitles = document.querySelectorAll(
    '.authorization-title .authorization-section__title'
  );

if (authTabs && authForms) {

  const urlParams = new URLSearchParams(window.location.search);
  const activeTab = urlParams.get('tab') || urlParams.get('form');


  let activeIndex = activeTab === 'Employers' ? 1 : 0;

  authTabs.forEach((tab, index) => {
    if (index === activeIndex) {
      tab.classList.add('active');
      authForms[index]?.classList.add('active');
      authTitles[index]?.classList.add('active');
    } else {
      tab.classList.remove('active');
      authForms[index]?.classList.remove('active');
      authTitles[index]?.classList.remove('active');
    }
  });

  authTabs?.forEach((item, i) => {
    item?.addEventListener('click', () => {
      if (item?.classList.contains('active')) return;

      authTabs?.forEach((t) => t.classList.remove('active'));
      authForms?.forEach((t) => t.classList.remove('active'));
      authTitles?.forEach((t) => t.classList.remove('active'));

      item?.classList.add('active');
      authForms[i]?.classList.add('active');
      authTitles[i]?.classList.add('active');
    });
  });
}
